import { Middleware } from "@nuxt/types"

const publicOnly: Middleware = async ({ app, store, redirect }) => {
  const hasToken = !!store.state.oauth.accessToken

  if (hasToken) {
    return redirect(app.localePath('index'))
  }

  return
}

export default publicOnly
